/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { FormConfig } from "@src/app/shared/form/FormConfig";
import { IsNarrowService } from '@src/app/shared/is-narrow.service';
import { DialogOptions } from '@src/app/shared/dialogs/pick-dialog/pick-dialog.component';
import { FormComponent } from '@src/app/shared/form/form.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogBannerComponent } from '@src/app/shared/dialogs/dialog-banner-component';

@Component({
    selector: 'app-edit-dialog',
    templateUrl: './edit-dialog.component.html',
    styleUrls: ['./edit-dialog.component.scss'],
    imports: [MatTooltipModule, MatIconModule, MatDialogContent, FormComponent, DialogBannerComponent]
})
export class EditDialogComponent implements OnInit {
    protected isNarrowSvc = inject(IsNarrowService);
    dialogRef = inject<MatDialogRef<EditDialogComponent>>(MatDialogRef);
    dialogOptions = inject<DialogOptions>(MAT_DIALOG_DATA);


    config: FormConfig;
    width = 500;
    height = 300;

    constructor() {
        const dialogOptions = this.dialogOptions;


        this.config = dialogOptions.config;
        if (dialogOptions.service) {
            this.config.service = dialogOptions.service;
        }
        if (!dialogOptions.config.mode) {
            this.config.mode = 'edit';
        }
        this.dialogRef.disableClose = true;
        //TODO - Override Params?....
    }

    ngOnInit(): void {
        this.width = this.dialogOptions.width ? this.dialogOptions.width : this.isNarrowSvc.screenWidth * .8;
        this.height = this.dialogOptions.height ? this.dialogOptions.height : this.isNarrowSvc.screenHeight * .8;
    }
}
